import { injectable } from "inversify";
import GroupRepository from "../../repositories/GroupRepository";
import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../entities/ExceptionEntity";
import UserEntity from "../../entities/UserEntity";

interface props {
    groupRepository: GroupRepository;
}

@injectable()
export default class SearchUsersOfGroupUseCase {
    _groupRepository: GroupRepository;

    constructor(_: props) {
        this._groupRepository = _.groupRepository;
    }
    public call = async (groupdIds: string[]): Promise<Either<ExceptionEntity, UserEntity[]>> => {
        return this._groupRepository.getUsersOfGroup(groupdIds);
    }
}

export const SearchUsersOfGroupUseCaseName = "SearchUsersOfGroupUseCase";
